import { useIsStartPageAugustRevisionEnabled } from "@mirage/august-revision-hook";
import { useDualMode } from "@mirage/service-experimentation/useDualMode";
import { usePublishHomepageSurveyEvent } from "@mirage/service-feedback/hooks/usePublishHomepageSurveyEvent";
import { useOnboardingValues } from "@mirage/service-onboarding/hooks";
import { logPageLoadMilestoneOnce } from "@mirage/service-operational-metrics/page-load";
import { useDashTitle } from "@mirage/shared/hooks/DashTitle";
import { useIsMobileSize } from "@mirage/shared/responsive/mobile";
import i18n from "@mirage/translations";
import classnames from "classnames";
import { DualModeOnboarding } from "../Onboarding/DualModeOnboarding/DualModeOnboarding";
import { StartPage } from "../StartPage";
import { WorkingSet } from "../WorkingSet";
import styles from "./HomePage.module.css";

export const HomePage: React.FC = () => {
  logPageLoadMilestoneOnce("HomePage start");

  useDashTitle(i18n.t("home"));
  usePublishHomepageSurveyEvent();
  const isMobileSize = useIsMobileSize();
  const isAugustStartPageEnabled = useIsStartPageAugustRevisionEnabled();
  const { showFullScreenTip } = useDualMode();
  const { setOnboardingValue } = useOnboardingValues();

  return (
    <div
      className={classnames(styles.resultPageContainer, {
        [styles.isMobile]: isMobileSize,
      })}
    >
      {showFullScreenTip && (
        <DualModeOnboarding
          onComplete={() =>
            setOnboardingValue("seenFullScreenDualModeTip", true)
          }
        />
      )}
      {isAugustStartPageEnabled ? <StartPage /> : <WorkingSet />}
    </div>
  );
};
